import { CommonApiResponse } from "../Controllers/Types/ApiResponse";
import { ContentListResponse } from "../Controllers/Types/ContactResponse";
import {
    ListResponse,
    projectServiceTypeResponse,
} from "../Controllers/Types/Project/ProjectResponse";
import {
    searchProjectAdderssResponse,
    serviceTypeResponse,
    subscriptionDetailsResponse,
} from "../Controllers/Types/Project/ProjectResponse";
import { ShareContact } from "../Controllers/Types/Project/ShareContactInterface";
import { SharedFolder } from "../Controllers/Types/Project/SharedFolder";
import apiClient from "./apiClient";
import { baseURL } from "./ApiConstant";

//PROJECT CONTACT LIST
export const ProjectContentListAPI = async (): Promise<ContentListResponse> => {
    try {
        const token = localStorage.getItem("token") || "";
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/project-contact-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

/* ************************************************************  search project address - start *****************************************************************/
export const searchProjectAddressGetAPI = async (
    search_address: string
): Promise<searchProjectAdderssResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/search-address-for-project`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ search_address }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data["data"] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************************  search project address - end *****************************************************************/

/* ************************************************************  service type - start *****************************************************************/
export const serviceTypeGetAPI = async (): Promise<serviceTypeResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/service-type/by-user-id`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data["data"] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const serviceTypeCreateAPI = async (
    name: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/service-type/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                massage: "Body error",
                errors: data["errors"],
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const serviceTypeUpdateAPI = async (
    serviceTypeId: number,
    name: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/service-type/update/${serviceTypeId}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
                body: JSON.stringify({ name }),
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************************  service type - end *****************************************************************/

/* ************************************************************  subscription details - start *****************************************************************/
export const subscriptionDetailsGetAPI =
    async (): Promise<subscriptionDetailsResponse> => {
        try {
            const token = localStorage.getItem("token");
            const FULL_TOKEN = `Bearer ${token}`;

            const response = await fetch(`${baseURL}/api/subscription-details`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            });

            const data = await response.json();

            if (response.status === 200) {
                return { status: true, statusCode: 200, data: data["data"] };
            } else if (response.status === 401) {
                return { status: false, statusCode: 401, massage: "Unauthorized" };
            } else if (response.status === 422) {
                return { status: false, statusCode: 422, massage: "Body error" };
            } else if (response.status === 404) {
                return { status: false, statusCode: 404, massage: "Not found" };
            } else {
                return { status: false, statusCode: 500, massage: "Error" };
            }
        } catch (error) {
            throw error;
        }
    };
/* ************************************************************  subscription details - end *****************************************************************/

/* ************************************************************  project part - start *****************************************************************/
export const projectCreateAPI = async (
    project: string,
    job_number: number,
    contact_id: number,
    subscription_id: number,
    commercial_client_project_info_id: number | null,
    domestic_client_info_id: number | null,
    project_type: string,
    description: string,
    end_of_date: string,
    service_type_ids: string,
    status: string,
    address: string,
    city: string,
    post_code: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project,
                job_number,
                contact_id,
                subscription_id,
                commercial_client_project_info_id,
                domestic_client_info_id,
                project_type,
                description,
                end_of_date,
                service_type_ids,
                status,
                address,
                city,
                post_code,
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectUpdateAPI = async (
    projectId: number,
    job_number: number,
    subscription_id: number,
    contact_id: number,
    commercial_client_project_info_id: number | null,
    domestic_client_info_id: number | null,
    project_type: string,
    description: string,
    end_of_date: string,
    service_type_ids: string,
    status: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project/update/${projectId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                job_number,
                subscription_id,
                contact_id,
                commercial_client_project_info_id,
                domestic_client_info_id,
                project_type,
                description,
                end_of_date,
                service_type_ids,
                status,
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectLicenseUpdateAPI = async (
    project_id: number,
    subscription_id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project-subscription-changed`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project_id,
                subscription_id
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectDeleteAPI = async (
    projectId: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project/delete/${projectId}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const getAllProjectsAPI = async (): Promise<ListResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/all-project/by-user-id`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data["data"] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectShareContact = async (
    project_id: number,
    share: ShareContact[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project/share`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ project_id, share }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************************  project part - end *****************************************************************/

/* ************************************************************ Folder service type part - start **************************************************************** */
export const projectFolderCreateAPI = async (
    folder: number,
    project_id: number,
    type: string,
    service_name: string,
    display_name: string,
    folder_type: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/folder/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                folder,
                project_id,
                type,
                service_name,
                display_name,
                folder_type,
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectFolderUpdateAPI = async (
    folderId: number,
    service_name: string,
    display_name: string
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const array = [
            {
                folder_id: folderId,
                service_name: service_name,
                display_name: display_name,
            },
        ];

        const response = await fetch(`${baseURL}/api/folder/update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ array }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectFolderDeleteAPI = async (
    folderId: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/folder/delete/${folderId}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

export const projectFolderGetAPI = async (
    projectId: number
): Promise<projectServiceTypeResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/project-folder/${projectId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data["data"] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************************ Folder service type part - end **************************************************************** */

/* ************************************************************ service type - Progress part - start **************************************************************** */

/* ************************************************************ service type - Progress part - end **************************************************************** */

/* ************************************************************ Project share folder part-start **************************************************************** */

// get share folders
export const getSharedFoldersByUserToken = async () => {
    try {
        const response = await apiClient.get(`/api/project/share/folder-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

export const moveFolder = async (
    project_id: number,
    share: SharedFolder[]
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const list = share.map((e) => e.folder_id);
        const response = await fetch(
            `${baseURL}/api/project/folder-move-to-project`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
                body: JSON.stringify({ project_id, list }),
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

/* ************************************************************ Project share folder part - end **************************************************************** */
